var render = function render(){var _vm=this,_c=_vm._self._c;return _c('state',{attrs:{"state":"success","heading":_vm.heading,"message":_vm.description,"link":_vm.redirectUri,"linkText":_vm.computedLinkText}})
}
var staticRenderFns = []

export { render, staticRenderFns }